import { useEffect, useState } from 'react';
import { InputText, PrimaryButton, SecondaryButton } from '../../../shared/ui/Inputs';
import { ErrorMessage } from '../../../shared/messages/messages';
import {
    createSapProductBranch,
    editSapProductBranch,
} from '../../../services/configuration/sapProductBranchService';

export const SapProductBranchForm = ({
    sap_code,
    branch_id,
    layout,
    product_id,
    onAction,
    isEditing,
}) => {
    const [_sapCode, setSapCode] = useState(
        (sap_code ?? '').toString().slice(0, 50)
    );
    const [_branchId, setBranchId] = useState((branch_id ?? '').toString());
    const [_layout, setLayout] = useState((layout ?? '').toString().slice(0, 1));
    const [_productId, setProductId] = useState((product_id ?? '').toString());

    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setSapCode((sap_code ?? '').toString().slice(0, 50));
        setBranchId((branch_id ?? '').toString());
        setLayout((layout ?? '').toString().slice(0, 1));
        setProductId((product_id ?? '').toString());
    }, [sap_code, branch_id, layout, product_id]);

    const validateForm = () => {
        if (!_sapCode.trim()) {
            setMessage('SAP Code é obrigatório');
            return false;
        }

        if (_sapCode.trim().length > 50) {
            setMessage('SAP Code deve ter no máximo 50 caracteres');
            return false;
        }

        if (!_branchId.trim() || !/^\d+$/.test(_branchId.trim())) {
            setMessage('Branch ID deve ser um número inteiro');
            return false;
        }

        if (!_layout.trim() || _layout.trim().length !== 1) {
            setMessage('Layout deve conter exatamente 1 caractere');
            return false;
        }

        if (_productId.trim() && !/^\d+$/.test(_productId.trim())) {
            setMessage('Product ID deve ser um número inteiro');
            return false;
        }

        return true;
    };

    const handleSubmit = async () => {
        setMessage('');
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
            const payload = {
                sap_code: _sapCode.trim(),
                branch_id: Number(_branchId.trim()),
                layout: _layout.trim(),
                product_id: _productId.trim() ? Number(_productId.trim()) : null,
            };

            if (isEditing) {
                await editSapProductBranch(sap_code, branch_id, payload);
            } else {
                await createSapProductBranch(payload);
            }

            onAction?.();
        } catch (error) {
            console.warn('Erro ao salvar SapProductBranch:', error);
            setMessage(error?.message || 'Erro ao salvar o registro');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div
            style={{
                padding: '15px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div style={{ flex: 1 }}>
                <div style={{ marginBottom: '20px' }}>
                    <label
                        style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}
                    >
                        SAP Code *
                    </label>
                    <InputText
                        style={{ width: '100%' }}
                        value={_sapCode}
                        onChange={(e) => setSapCode((e.target.value ?? '').slice(0, 50))}
                        placeholder="Digite o SAP Code"
                        disabled={isSubmitting}
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label
                        style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}
                    >
                        Branch ID *
                    </label>
                    <InputText
                        style={{ width: '100%' }}
                        value={_branchId}
                        onChange={(e) =>
                            setBranchId((e.target.value ?? '').replace(/\D/g, ''))
                        }
                        placeholder="Digite o Branch ID"
                        disabled={isSubmitting}
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label
                        style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}
                    >
                        Layout *
                    </label>
                    <InputText
                        style={{ width: '100%' }}
                        value={_layout}
                        onChange={(e) => setLayout((e.target.value ?? '').slice(0, 1))}
                        placeholder="Digite o Layout (1 caractere)"
                        disabled={isSubmitting}
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label
                        style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}
                    >
                        Product ID
                    </label>
                    <InputText
                        style={{ width: '100%' }}
                        value={_productId}
                        onChange={(e) =>
                            setProductId((e.target.value ?? '').replace(/\D/g, ''))
                        }
                        placeholder="Digite o Product ID"
                        disabled={isSubmitting}
                    />
                </div>

                {message ? <ErrorMessage>{message}</ErrorMessage> : null}
            </div>

            <div
                style={{
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'flex-end',
                    flexShrink: 0,
                }}
            >
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={() => onAction()}
                    style={{ width: '100px' }}
                >
                    Cancelar
                </SecondaryButton>
                <PrimaryButton
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    style={{ width: '100px' }}
                >
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                </PrimaryButton>
            </div>
        </div>
    );
};
